export const ACCEPT_SERVICE = {
  APPLICATION_JSON: "application/json",
  MULTIPART_DATA: "multipart/form-data",
  FORM_URL_ENCODED: "application/x-www-form-urlencoded",
  SPREADSHEAT_DATA:
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  PDF_FILE: "application/pdf",
};
export const DEFAULT_AUTH_TOKEN = "Basic c3RyaXgtdWk6";
export const DEFAULT_ACCEPT_SERVICE = ACCEPT_SERVICE.FORM_URL_ENCODED;

export const BASE_URL = `https://unimark.unisoftllc.com:9091/unimark/api/`;